<template>
  <!-- モーダル START -->
  <b-modal width="680px" :active.sync="isShowModal">
    <div class="card" style="border-radius: 5px;">
      <header class="card-header">
        <div class="cover-filter">
          <p class="card-header-title title">
            履歴書の登録
          </p>
        </div>
      </header>
      <div class="card-content" v-if="imageUploadStep===1">
        <h2 style="width: 100%; padding-left: 16px; padding-top: 16px;">画像のアップロードから履歴書が登録できます。</h2>
        <h2 style="width: 100%; padding-left: 16px;">カメラなどで左半分・右半分とお取りいただき、画像をアップロードしてください。</h2>
        <hr>
        <div style="width: 80%; height: 80%; display: flex; justify-content: space-between; padding: 8px; margin: 0 auto;">
          <div style="width: 49%; height: 100%;">
            <div class="wrapper-cover-img">
              <div style="position: absolute; display: flex; justify-content: center; align-items: center; z-index: 1; width: 100%; height: 100%; color: white; font-size: 120px; background: rgba(0, 0, 0, 0.5);">
                A
              </div>
              <img src="@/assets/template/resume_A.jpeg" style="width: 70%; height: auto;"/>
            </div>
            <b-upload style="margin: 16px;" v-model="fileLeft">
              <a class="button is-primary">左半分をアップロード</a>
            </b-upload>
            <p v-if="fileLeft != null">アップロード完了</p>
          </div>
          <div style="width: 49%; height: 100%;">
            <div class="wrapper-cover-img">
              <div style="position: absolute; display: flex; justify-content: center; align-items: center; z-index: 1; width: 100%; height: 100%; color: white; font-size: 120px; background: rgba(0, 0, 0, 0.5);">
                B
              </div>
              <img src="@/assets/template/resume_B.jpeg" style="width: 70%; height: auto;"/>
            </div>
            <b-upload style="margin: 16px;" v-model="fileRight">
              <a class="button is-primary">右半分をアップロード</a>
            </b-upload>
            <p v-if="fileRight != null">アップロード完了</p>
          </div>
        </div>
        <hr>
        <div style="width: 100% position: absolute; display: flex; justify-content: center;">
          <b-field style="width: 100%">
            <div style="width: 50%; margin: 8px;">
              <button
                class="button is-primary"
                style="width: 100%;"
                @click="registerOCR()"
                :disabled="!fileLeft || !fileRight"
              >
                読み込む
              </button>
            </div>
          </b-field>
        </div>
      </div>
      <div class="card-content" style="padding: 0;" v-if="imageUploadStep===2">
        <div style="padding: 16px;" v-if="isOCRReading">
          <span class="mdi mdi-loading mdi-spin mdi-48px"></span>
          <p>現在履歴書を読み込んでおります。今しばらくお待ちください。</p>
        </div>
        <ResumeTable
          @modalOff="modalOff"
          :ocrData="ocrData"
          :seeker="seeker"
          :fileLeft="fileLeft"
          :fileRight="fileRight"
          :isDuplicateSeekerFlag="isDuplicateSeekerFlag"
          :isGetRoboTalk="isGetRoboTalk"
          v-if="!isOCRReading"
          :PCTRLLOG="CTRLLOG"
        />
      </div>
    </div>
  </b-modal>
  <!-- モーダル END -->

</template>

<script>
import { mapState } from 'vuex'
import draggable from 'vuedraggable'
import ResumeTable from '@/views/DashBoard/Manage/ResumeTable'
import controlLogMixin from '@/mixins/controlLogMixin'
export default {
  name: 'Manage',
  componentName: 'Manage',
  components: {
    draggable,
    ResumeTable
  },
  mixins: [
    controlLogMixin
  ],
  props: {
    isDuplicateSeekerFlag: {
      type: Boolean,
      required: false,
      default: false,
    },
    isGetRoboTalk: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  data () {
    return {
      months: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      year: 1920,
      month: 1,
      date: 1,
      tempSid: null,
      tempGrp: null,
      resume: {},
      imageUploadStep: 1,
      isShowModal: false,
      fileLeft: null,
      fileRight: null,
      ocrResumeRows: [],
      seeker: null,
      prevSeekerID: null,// 前回開いた時のseekerID,
      readyForSending: false
    }
  },
  watch: {
    isShowModal () {
      if (this.isShowModal && (this.seeker.id != this.prevSeekerID)) {
        // 前回とは異なるseekerで開いた
        this.imageUploadStep = 1
        this.fileLeft  = null
        this.fileRight = null
        this.ocrResumeRows = []
        this.readyForSending = false
        this.prevSeekerID = this.seeker.id
      } 
    },
    fileLeft () {
      if (this.fileLeft) {
        let reader = new FileReader()
        console.log(this.fileLeft)
        reader.onload = (e) => {
          console.log(e)
          this.ocrResumeRows.push({
            filename: this.fileLeft.name,
            data: e.target.result.replace(/^.*,/, '')
          })
          this.readyForSending = Boolean(this.ocrResumeRows[0]) && Boolean(this.ocrResumeRows[1])
        }
        reader.readAsDataURL(this.fileLeft)
      }
    },
    fileRight () {
      if (this.fileRight) {
        let reader = new FileReader()
        reader.onload = (e) => {
          console.log(e)
          this.ocrResumeRows.push({
            filename: this.fileRight.name,
            data: e.target.result.replace(/^.*,/, '')
          })
          this.readyForSending = Boolean(this.ocrResumeRows[0]) && Boolean(this.ocrResumeRows[1])
        }
        reader.readAsDataURL(this.fileRight)
      }
    },
    start () {
      this.makeCSV()
    },
    end () {
      this.makeCSV()
    },
    delimiter () {
      this.makeCSV()
    },
    isHeader () {
      this.makeCSV()
    }
  },
  methods: {
    initTable () {
      this.shikakuTable = []
      this.keirekiTable = []
      this.keirekiTable2 = []
    },
    registerOCR () {
      this.$store.dispatch('directtalk/uploadOCR',this.ocrResumeRows)
      this.imageUploadStep++
    },
    modalOff () {
      this.fileLeft  = null
      this.fileRight = null
      this.imageUploadStep = 1
      this.readyForSending = false
      this.isShowModal = false
    },
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('directtalk', ['applylist', 'isApplyListLoading', 'isApplyListNone', 'downloadCSV', 'isMakingCSV', 'resumeLoading', 'isOCRReading', 'ocrData', 'seekers']),
  }
}
</script>

<style scoped>
table td:not([align]), table th:not([align]) {
  text-align: center;
}
table {
  width: 100%;
  border-collapse:collapse;
  margin: 0 auto;
}
td,th {
  padding:10px;
  margin: auto;
  max-width: 350px;
  font-size: smaller;
}
td {
  text-align: left;
}
th {
  color:#fff;
  background:#AA0066;
}
table tr:nth-child(odd) {
  background:#ffeeff;
}
table tr:nth-child(even) {
  background:#fafafa;
}
.recruit-table {
  display: block;
  height: calc(100vh - 200px);
  width: calc(100vw - 280px);
  overflow: scroll;
}
.recruit-table::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  visibility: hidden;
}
.container-manage {
  height: calc(100vh - 80px);
  width: calc(100% - 200px);
  overflow-y: scroll;
}
.container-manage::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  visibility: hidden;
}
.header-box {
  width: calc(100% - 80px);
  margin: 10px 40px;
  margin-bottom: 25px;
  padding: 15px 10px;
  display: flex;
  justify-content: space-between;
  border-bottom: dotted 6px #323;
  flex-wrap: wrap;
}
.header-menu {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 5px;
}
.export-body::-webkit-scrollbar {
  width:  10px !important;
  height: 10px !important;
  visibility: visible !important;
}
.main-box {
  width: 100%;
  padding: 0;
}
.table-list {
  border: solid thin #ccc;
  height: calc(100vh - 180px);
  overflow: scroll;
}
.export-box {
  height: calc(100vh - 130px);
  width: 100%;
}
.export-body {
  height: calc(100vh - 187px);
  width: 100%;
  overflow-x: scroll;
  overflow-y: hidden;
  display: -webkit-inline-box;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.export-body::-webkit-scrollbar {
  width:  0px !important;
  height: 10px !important;
  visibility: visible !important;
  background: white;
}
.export-list {
  margin: 20px;
  margin-right: 5px;
  margin-left:  10px;
  height: calc(100% - 40px);
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  background: rgba(200, 200, 200, 0.5);
  border-radius: 10px;
}
.export-list-header {
  background: rgba(0, 0, 0, 0.7);
  border-radius: 10px;
  width: 200px;
  height: 40px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  color: white;
  font-size: 16px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.export-list-body {
  border-radius: 10px;
  width: 190px;
  text-align: center;
  color: black;
  font-size: 16px;
  margin: 5px;
  margin-bottom: 0;
  padding: 10px;
  background: white;
  min-height: 44px;
}
.export-header {
  height: 50px;
  width: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.add-box {
  margin: 20px;
  margin-left: 5px;
  margin-right: 10px;
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  /* padding: 20px; */
  width: 210px;
  height: 40px;
}
.date-box {
  width: 40%;
  padding-left: 10px;
  padding-right: 10px;
  display: flex;
  justify-content: space-between
}
.option-box {
  width: 60%;
  padding-right: 10px; 
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 5px;
  overflow: scroll;
}
.resume-btn {
  border-radius: 50%;
  height: 36px;
  width: 36px;
  font-size: 16px;
}

.wrapper-cover-img {
  position: relative;
}

.input-box {
  text-align: left;
  width: 100%;
  display: flex;
  border-bottom: solid thin #ccc !important;
  border-right: solid thin #ccc !important;
  border-left: solid thin #ccc !important;
}
.input-label {
  width: 30%;
  border-right: solid thin #ccc !important;
  background: rgba(250, 230, 230) !important;
  padding: 8px !important;
}
.input-modal {
  width: calc(100% - 30%);
  height: 40px;
  color: #222 !important;
  font-size: 16px !important;
  background: #f8f8f8 !important;
  padding: 8px !important;
  border-radius: 0;
  border: none;
  box-shadow: none;
}

.table-box {
  width: 100%;
}
.table-box-header {
  border: solid thin #ccc !important;
  background: rgb(250, 230, 230) !important;
  color: #222;
  padding: 8px !important;
}
.input-table {
  height: 40px;
  color: #222 !important;
  font-size: 16px;
  background: #f8f8f8 !important;
  padding: 8px !important;
  border-radius: 0;
  box-shadow: none !important;
}
.container-birth{
  display: flex
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/Manage/ModalEdit.vue